var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-tooltip',_vm._b({scopedSlots:_vm._u([{key:"activator",fn:function({ on, attrs }){return [_c('v-btn',_vm._g(_vm._b({on:{"click":function($event){return _vm.$emit('click')}}},'v-btn',{
        ...attrs,
        ..._vm.btnProps,
      },false),on),[_vm._t("default")],2)]}}],null,true)},'v-tooltip',_vm.tooltipProps,false),[_c('span',[_vm._v(_vm._s(_vm.title))])])
}
var staticRenderFns = []

export { render, staticRenderFns }